// ./src/undergradMajors/getUndergradMajors.ts
//
// Synchronous function to retrieve static undergraduate major data.

// Local type, constants, and utility imports.
import { latestAllUndergradMajors } from "@src/autoGenerated/latestAllUndergradMajors";
import type { UndergradMajor } from "@src/schemas/UndergradMajor";

export function getUndergradMajors(): UndergradMajor[] {
  return latestAllUndergradMajors;
}
